import React, { useEffect, useState } from 'react'

import StoreContext from './context';
import useBuilder from './useBuilder';

const withBuilder = (WrappedComponent) => {

  return function(props) {
    const [canvas, setCanvas] = useState(null);
    const builder = useBuilder(canvas, props.manifest, props.shareData);

    return (
      <StoreContext.Provider value={{ builder, setCanvas }}>
        <WrappedComponent {...props} />
      </StoreContext.Provider>
    )
  }
}

export default withBuilder;
